// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"61c30035","402":"40f1d9c5","893":"ef7bdb9f"}[chunkId] + ".chunk.css";
};